import { render, staticRenderFns } from "./AuditLogsTable.vue?vue&type=template&id=20a624ee&"
import script from "./AuditLogsTable.vue?vue&type=script&lang=js&"
export * from "./AuditLogsTable.vue?vue&type=script&lang=js&"
import style0 from "./AuditLogsTable.vue?vue&type=style&index=0&id=20a624ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports